import {
  SET_LIVE_SCORES_FILTER_REQUEST_OBJECT,
  GET_LIVE_SCORES_CLEAR_ALL_FILTER,
  GET_LIVE_SCORES_CLEAR_FILTER,
  SET_LIVE_SCORES_FILTERS_FROM_LOCAL_STORAGE
} from 'Store/constants';
import { dateToJavaTimeConverter } from 'Utils/dateConverters';

export const initialDate = dateToJavaTimeConverter(new Date());

const initialState = {};

export default (state = initialState, action) => {
  switch (action.type) {
    case SET_LIVE_SCORES_FILTERS_FROM_LOCAL_STORAGE:
    {
      return action.payload?.liveScoresFilterRequest || initialState;
    }

    case SET_LIVE_SCORES_FILTER_REQUEST_OBJECT:
    {
      const { eventType, filterObject } = action.payload;

      return {
        ...state,
        [eventType]: filterObject
      };
    }

    case GET_LIVE_SCORES_CLEAR_ALL_FILTER:
      return {
        ...state,
        [action.payload]: {
          competitionIds: [],
          onlyLive: false,
          streamOnTv: false,
          streamOnBilyoner: false,
          liveCanBet: false,
          date: initialDate
        }
      };

    case GET_LIVE_SCORES_CLEAR_FILTER:
      return {
        ...state,
        [action.payload]: {
          ...state[action.payload],
          competitionIds: [],
          streamOnBilyoner: false,
          liveCanBet: false
        }
      };

    default:
      return state;
  }
};
